import {get, isEmpty, isNil} from 'lodash'
import arrayMove from 'array-move'

export const reorderListByIndex = (items = [], oldIndex, newIndex, key = 'order') => {
  return reorderList(arrayMove(items, oldIndex, newIndex), key)
}

export const reorderList = (items = [], key = 'order') => {
  return items.map((item, index) => {
    item[key] = index
    return item
  })
}

export const updateItemInList = (items = [], item) => {
  return items.map(listItem => {
    return listItem.id === item.id
        ? item
        : listItem
  })
}

export const getItemKey = (items, id, key = 'name') => {
  const item = items.find(item => item.id === id)
  return isNil(item)
      ? null
      : get(item, key, null)
}

export const addToList = (items = [], item, index) => {
  const ret = [...items]
  ret.splice(index, 0, item)
  return ret
}

export const getIds = (items) => {
  return isEmpty(items) ? [] : items.map(row => row.id)
}

export const getNextValue = (data, initialValue) => {
  if (isEmpty(data)) return initialValue
  return Math.max(...data.map(d => d.value)) + 1
}
